import { subscribe } from '../../common/errors/sagas';
import { notificationError, notificationInfo } from '../../common/errors/notificationTypes';
import { subscribeConfiguration } from '../../common/saveconfiguration/sagas';

const pre = 'MONITORINGSUMMARY/';

export const INITIALISE = `${pre}INITIALISED`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const FETCH_IMSUMMARIES_SUCCEEDED = `${pre}FETCH_IMSUMMARIES_SUCCEEDED`;
export const FETCH_IMSUMMARIES_FAILED = `${pre}FETCH_IMSUMMARIES_FAILED`;
export const FETCH_IMSUMMARIES_RETURNED_EMPTY = `${pre}FETCH_IMSUMMARIES_RETURNED_EMPTY`;
export const REFRESH_DATA = `${pre}REFRESH_DATA`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_MONITORING_SUMMARIES_COLUMNS = `${pre}SET_IMSUMMARIES_COLUMNS`;
export const CSV_EXPORT_EMPTY = `${pre}CSV_EXPORT_EMPTY`;
export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;
export const SET_ALL_GRID_SORTS = `${pre}SET_ALL_GRID_SORTS`;
export const SET_DEFAULT_CONFIG = `${pre}SET_DEFAULT_CONFIG`;
export const FETCH_DEFAULT_CONFIG_FAILED = `${pre}FETCH_DEFAULT_CONFIG_FAILED`;
export const APPLY_CLIENT_FILTERS = `${pre}APPLY_CLIENT_FILTERS`;
export const SWITCH_CURRENCIES = `${pre}SWTCH_CURRENCIES`;
export const REFRESH_MONITORING_SUMMARY = `${pre}REFRESH_MONITORING_SUMMARY`;


subscribe(FETCH_IMSUMMARIES_RETURNED_EMPTY, 'Fetch CSA Monitoring Summaries returned an empty list', notificationInfo);
subscribe(FETCH_IMSUMMARIES_FAILED, 'Failed to fetch CSA Monitoring Summaries', notificationError);
subscribeConfiguration(SET_MONITORING_SUMMARIES_COLUMNS, 'monitoringSummary');
subscribe(CSV_EXPORT_EMPTY, 'Failed to export as CSV - no data', notificationError);
subscribe(FETCH_DEFAULT_CONFIG_FAILED, 'Failed to fetch the default configuration', notificationInfo);

export const refreshMonitoringSummary = () => ({
    type: REFRESH_MONITORING_SUMMARY
});

export const initialise = () => ({
    type: INITIALISE
});

export const setInitialised = () => ({
    type: SET_INITIALISED
});

export const fetchImSummariesSucceeded = (data, serverFilters) => ({
    type: FETCH_IMSUMMARIES_SUCCEEDED,
    data,
    serverFilters
});

export const fetchImSummariesEmpty = error => ({
    type: FETCH_IMSUMMARIES_RETURNED_EMPTY,
    error
});

export const fetchImSummariesFailed = error => ({
    type: FETCH_IMSUMMARIES_FAILED,
    error
});

export const refreshData = () => ({
    type: REFRESH_DATA
});

export const setLoading = () => ({
    type: SET_LOADING
});

export const setMonitoringSummariesColumns = data => ({
    type: SET_MONITORING_SUMMARIES_COLUMNS,
    data
});

export const csvExportEmpty = error => ({
    type: CSV_EXPORT_EMPTY,
    error
});

export const setAllGridSorts = data => ({
    type: SET_ALL_GRID_SORTS,
    data
});

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});

export const setDefaultConfig = columns => ({
    type: SET_DEFAULT_CONFIG,
    columns
});

export const fetchDefaultConfigFailed = error => ({
    type: FETCH_DEFAULT_CONFIG_FAILED,
    error
});

export const applyClientFilters = clientFilters => ({
    type: APPLY_CLIENT_FILTERS,
    clientFilters
});

export const switchCurrencies = () => ({
    type: SWITCH_CURRENCIES
});
